import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Navbar, Nav, NavDropdown, Container, Button } from 'react-bootstrap';

import './NavBarHeader.css';

import Str from '../../../support/Str';
import { Auth } from '../../../support';
import { resetStore } from '../../../store';

class NavBarReceptoresHeader extends Component {
  state = {};

  constructor(props) {
    super(props);

    const { user } = Auth.getData();

    this.state = {
      user,
      toggle: 0,
      loggedIn: true,
      title: 'App',
    };

    window.setAppTitle = this.setAppTitle;
  }

  componentWillUnmount = () => {
    this.setState = () => {};
  };

  handleLogout = async () => {
    resetStore();

    setTimeout(async () => {
      await Auth.logout();

      this.setState({
        loggedIn: false,
      });
    }, 500);
  };

  setAppTitle = (title) => {
    this.setState({
      title,
    });
  };

  toggleSideBar = () => {
    this.props.onToggleSidebar();
  };

  render() {
    const { user, title, loggedIn } = this.state;
    const { fluid } = this.props;

    if (!loggedIn) {
      return <Redirect to="/ext/receptores/auth/login" />;
    }

    return (
      <Navbar
        className="navbar-header fa-navbar"
        bg="light"
        expand="lg"
      >
        <Container
          fluid={fluid}
          className="px-0"
        >
          <Navbar.Brand
            as="div"
            to="/app/dashboard"
          >
            <Button
              type="button"
              variant="link"
              className="d-inline d-lg-none d-xl-none"
              onClick={this.toggleSideBar}
            >
              <FontAwesomeIcon icon={['fas', 'indent']} />
            </Button>
            <span className="d-none d-lg-inline d-xl-inline px-3"></span>
            <span className="d-none d-sm-inline d-md-inline d-lg-inline d-xl-inline">{title}</span>
          </Navbar.Brand>
          <Nav>
            <NavDropdown
              title={Str.only(user.nombre, 15)}
              id="basic-nav-dropdown"
              alignRight
            >
              <NavDropdown.Item
                as={Link}
                to="/ext/receptores/perfil"
              >
                Mi cuenta
              </NavDropdown.Item>

              <NavDropdown.Item
                as="div"
                to="/auth/logout"
                onClick={this.handleLogout}
              >
                Cerrar sesión
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Container>
      </Navbar>
    );
  }
}

export default NavBarReceptoresHeader;
